import { useState } from "react";

const useUserDetails = () => {
  const [userDetails, setUserDetails] = useState(() => {
    const userData = localStorage.getItem('object_Data');
    return userData ? JSON.parse(userData) : {};
  });

  return {
    userDetails,
    isMSP: userDetails?.allowMSP,
    isSaaS: userDetails?.allowSaaS,
    dateFormat: userDetails?.RegionalInfo?.ShortDateFormat?.toUpperCase(),
    clientId: userDetails?.objId_Client,
    setUserDetails,
  };
}

export default useUserDetails;
